@if (readonly) {
  <div class="floating-label-container">
    <div
      style="
        position: relative;
        border: 1px solid #dddddd;
        border-radius: 4px;
        padding: 0px;
      "
    >
      @if (this.type == TextModes.CurrencyUSD) {
        <div class="leftOverlay">$</div>
      }
      @if (this.type == TextModes.Percent) {
        <div class="rightOverlay">%</div>
      }
      @if (this.type != TextModes.Password) {
        <input
          type="text"
          style="padding: 7px 0px 7px 7px"
          [disabled]="true"
          [class]="
            this.type == TextModes.CurrencyUSD || this.type == TextModes.Percent
              ? 'floatText floatTextExtraPadding'
              : 'floatText'
          "
          [(ngModel)]="boundValue"
          [style.width.%]="control_width_pct"
          [style.width.px]="control_width_px"
        />
      }
      @if (this.type == TextModes.Password) {
        <input
          type="password"
          [disabled]="true"
          class="floatText"
          [(ngModel)]="boundValue"
          [style]="style"
          [style.width.%]="control_width_pct"
          [style.width.px]="control_width_px"
        />
      }
    </div>
    <div class="floatLabel">{{ label }}</div>
  </div>
}

<div [style]="style">
  @if (!readonly) {
    <div class="floating-label-container">
      <!-- TODO: padding-left should be conditional based on whether there's left overlay or right overlay -->
      <div
        style="
          position: relative;
          align-items: center;
          border: 1px solid #dddddd;
          border-radius: 4px;
          padding: 5px;
          padding-left: 10px;
          padding-bottom: 8px;
        "
      >
        @if (this.type == TextModes.CurrencyUSD) {
          <div class="leftOverlay">$</div>
        }
        @if (this.type == TextModes.Percent) {
          <div class="rightOverlay">%</div>
        }
        <!-- <div *ngIf="hint && hint != ''" class="rightOverlay" style="font-size:.9em; color:#777777; font-style: italic;">&nbsp;{{hint}}</div> -->
        @if (this.type != TextModes.Password) {
          <input
            type="text"
            [value]="defaultText"
            [placeholder]="hint"
            [disabled]="disabled"
            class="floatText"
            [attr.tid]="testId"
            id="{{ myId }}"
            #textbox
            [(ngModel)]="boundValue"
            (keyup)="_handle_onKeyUp($event)"
            [style.width.%]="control_width_pct"
            [style.width.px]="control_width_px"
            (blur)="handle_onBlur($event)"
          />
        }
        @if (this.type == TextModes.Password) {
          <input
            type="password"
            class="floatText"
            [attr.tid]="testId"
            id="{{ myId }}"
            #textbox
            [(ngModel)]="boundValue"
            (keyup)="_handle_onKeyUp($event)"
            [style]="style"
            [style.width.%]="control_width_pct"
            [style.width.px]="control_width_px"
            (blur)="handle_onBlur($event)"
          />
        }
        <label for="textbox" class="tb-validation-msg" [hidden]="isValid">{{
          validationMsg
        }}</label>
      </div>
      <div [class]="label ? 'floatLabel' : ''">{{ label }}</div>
      @if (helpText != '') {
        <mat-icon
          class="iconOverlay"
          matTooltip="{{ helpText }}"
          [ngStyle]="{ color: '#6b7475' }"
          >info</mat-icon
        >
      }
      <!-- <div *ngIf="helpText != ''" class="helpOverlay" style="visibility: visible; " (mouseover)="showHelp($event);">?</div>
      <div *ngIf="helpVisible && helpText != ''" id="{{myId}}_h" (mouseout)="hideHelp($event)" (click)="$event.stopPropagation()" class="contextHelpBox">
        {{helpText}}
      </div> -->
    </div>
  }
  @if (this.type == TextModes.CurrencyUSD) {
    <div
      style="
        margin-top: -10px;
        font-size: 0.9em;
        color: #777777;
        font-style: italic;
      "
    >
      USD
    </div>
  }
</div>
